export default __webpack_public_path__ + "static/media/federated-user.223da9bf.svg";